import { render, staticRenderFns } from "./ViewCoutUserSentSmsHistoryAll.vue?vue&type=template&id=24810f55&scoped=true"
import script from "./ViewCoutUserSentSmsHistoryAll.vue?vue&type=script&lang=js"
export * from "./ViewCoutUserSentSmsHistoryAll.vue?vue&type=script&lang=js"
import style0 from "./ViewCoutUserSentSmsHistoryAll.vue?vue&type=style&index=0&id=24810f55&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24810f55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24810f55')) {
      api.createRecord('24810f55', component.options)
    } else {
      api.reload('24810f55', component.options)
    }
    module.hot.accept("./ViewCoutUserSentSmsHistoryAll.vue?vue&type=template&id=24810f55&scoped=true", function () {
      api.rerender('24810f55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifihistory/ViewCoutUserSentSmsHistoryAll.vue"
export default component.exports